const DEFAULT_SOURCE_CHUNK_PREVIEW_CHARS = 800;

const formatHiddenCount = (count: number): string => count.toLocaleString();

export const truncateSourceTextForDisplay = (
  text: string | null | undefined,
  maxChars: number = DEFAULT_SOURCE_CHUNK_PREVIEW_CHARS,
): string => {
  const value = text || '';
  if (value.length <= maxChars) {
    return value;
  }

  const preview = value.slice(0, maxChars).trimEnd();
  const hiddenCount = Math.max(value.length - preview.length, 0);
  return `${preview}…\n\n[${formatHiddenCount(hiddenCount)} characters hidden in UI]`;
};

export const truncateSourceMarkdownForDisplay = (
  text: string | null | undefined,
  maxChars: number = DEFAULT_SOURCE_CHUNK_PREVIEW_CHARS,
): string => {
  const truncated = truncateSourceTextForDisplay(text, maxChars);
  return truncated.replace(/\n\n\[([\d,]+ characters hidden in UI)\]$/, '\n\n_$1_');
};

const SOURCE_LINK_BLOCK_REGEX = /(\*\*[^\n]+\*\*\n)([\s\S]*?)(\n\[Source\]\([^)]+\))/g;

/**
 * Truncate only source chunk bodies in markdown generated for Show Thinking.
 * The original tool-call payload remains untouched in state/storage; this is
 * purely a render-time transformation to avoid expensive markdown rendering of
 * very large retrieved chunks.
 */
export const truncateSourceChunksInMarkdownForDisplay = (
  markdown: string,
  maxChars: number = DEFAULT_SOURCE_CHUNK_PREVIEW_CHARS,
): string => {
  if (!markdown) {
    return markdown;
  }

  return markdown.replace(SOURCE_LINK_BLOCK_REGEX, (match, title, body, sourceLink) => {
    if (!String(body).trim()) {
      return match;
    }

    return `${title}${truncateSourceMarkdownForDisplay(String(body).trim(), maxChars)}${sourceLink}`;
  });
};
